module.exports = __webpack_public_path__ + "static/media/PPT-next.15cd8a52.svg";